const Layout = () => import('@/views/layout/Layout.vue')
export default [
  {
    path: '/pms',
    component: Layout,
    redirect: '/pms/product',
    name: 'pms',
    meta: { title: '商城管理', icon: 'product' },
    children: [{
      path: 'product',
      name: 'product',
      component: () => import('@/views/pms/product/index'),
      meta: { title: '商品列表', icon: 'product-list' }
    },
    {
      path: 'addProduct',
      name: 'addProduct',
      component: () => import('@/views/pms/product/add'),
      meta: { title: '添加商品', icon: 'product-add' }
    },
    {
      path: 'updateProduct',
      name: 'updateProduct',
      component: () => import('@/views/pms/product/update'),
      meta: { title: '修改商品', icon: 'product-add' },
      hidden: true
    },
    {
      path: 'detailProduct',
      name: 'detailProduct',
      component: () => import('@/views/pms/product/detail'),
      meta: { title: '修改商品', icon: 'product-add' },
      hidden: true
    },
    {
      path: 'afterSale',
      name: 'afterSale',
      component: () => import('@/views/order/afterSale'),
      meta: { title: '退货订单', icon: 'order-return' }
    },
    // {
    //   path: 'productTrating',
    //   name: 'productTrating',
    //   component: () => import('@/views/pms/producTrating/index'),
    //   meta: {title: '商品评价', icon: 'product-cate'}
    // },
    // {
    //   path: 'productCate',
    //   name: 'productCate',
    //   component: () => import('@/views/pms/productCate/index'),
    //   meta: {title: '商品分类', icon: 'product-cate'}
    // },
    {
      path: 'order',
      name: 'order',
      component: () => import('@/views/order/index'),
      meta: { title: '订单管理', icon: 'order-return' }
    },
    // {
    //   path: 'orderSeting',
    //   name: 'orderSeting',
    //   component: () => import('@/views/order/orderSeting/index'),
    //   meta: {title: '订单设置', icon: 'product-list'}
    // },
    {
      path: 'threasion',
      name: 'threasion',
      component: () => import('@/views/order/orderSeting/threasion'),
      meta: { title: '退货原因', icon: 'product-list' },
      hidden: true
    },
    {
      path: 'kdmodle',
      name: 'kdmodle',
      component: () => import('@/views/order/orderSeting/kdmodle'),
      meta: { title: '快递单模版', icon: 'product-list' },
      hidden: true
    },
    {
      path: 'thAddres',
      name: 'thAddres',
      component: () => import('@/views/order/orderSeting/thaddres'),
      meta: { title: '收货地址', icon: 'product-list' },
      hidden: true
    },
    {
      path: 'addProductCate',
      name: 'addProductCate',
      component: () => import('@/views/pms/productCate/add'),
      meta: { title: '添加商品分类' },
      hidden: true
    },
    {
      path: 'updateProductCate',
      name: 'updateProductCate',
      component: () => import('@/views/pms/productCate/update'),
      meta: { title: '修改商品分类' },
      hidden: true
    },
    // {
    //   path: 'productAttr',
    //   name: 'productAttr',
    //   component: () => import('@/views/pms/productAttr/index'),
    //   meta: {title: '商品类型', icon: 'product-attr'}
    // },
    {
      path: 'productAttrList',
      name: 'productAttrList',
      component: () => import('@/views/pms/productAttr/productAttrList'),
      meta: { title: '商品属性列表' },
      hidden: true
    },
    {
      path: 'addProductAttr',
      name: 'addProductAttr',
      component: () => import('@/views/pms/productAttr/addProductAttr'),
      meta: { title: '添加商品属性' },
      hidden: true
    },
    {
      path: 'updateProductAttr',
      name: 'updateProductAttr',
      component: () => import('@/views/pms/productAttr/updateProductAttr'),
      meta: { title: '修改商品属性' },
      hidden: true
    },
    // {
    //   path: 'brand',
    //   name: 'brand',
    //   component: () => import('@/views/pms/brand/index'),
    //   meta: {title: '品牌管理', icon: 'product-brand'}
    // },
    {
      path: 'addBrand',
      name: 'addBrand',
      component: () => import('@/views/pms/brand/add'),
      meta: { title: '添加品牌' },
      hidden: true
    },
    {
      path: 'updateBrand',
      name: 'updateBrand',
      component: () => import('@/views/pms/brand/update'),
      meta: { title: '编辑品牌' },
      hidden: true
    }
    ]
  },
  {
    path: '/writeOff',
    component: Layout,
    redirect: '/writeOff/offGoods',
    name: 'writeOff',
    meta: { title: '核销管理', icon: 'form' },
    children: [{
      path: 'offGoods',
      name: 'offGoods',
      component: () => import('@/views/writeOff/offGoods/index'),
      meta: { title: '核销商品管理', icon: 'product-list' }
    },
    {
      path: 'addOff',
      name: 'addOff',
      component: () => import('@/views/writeOff/offGoods/addOff'),
      meta: { title: '添加核销商品', icon: 'product-add' },
      hidden: true
    },
    {
      path: 'offOrder',
      name: 'offOrder',
      component: () => import('@/views/writeOff/offOrder/index'),
      meta: { title: '核销订单管理', icon: 'product-attr' }
    }
    ]
  },
  // {
  //   path: '/member',
  //   component: Layout,
  //   redirect: '/member/memberList',
  //   name: 'member',
  //   meta: {title: '会员管理', icon: 'product'},
  //   children: [{
  //     path: 'memberList',
  //     name: 'memberList',
  //     component: () => import('@/views/memberManagement/menberList/index'),
  //     meta: {title: '会员列表', icon: 'product-list'}
  //   },
  //   {
  //     path: 'memberShip',
  //     name: 'memberShip',
  //     component: () => import('@/views/memberManagement/memberShip/index'),
  //     meta: {title: '会员套餐', icon: 'product-list'}
  //   },
  //   {
  //     path: 'addShip',
  //     name: 'addShip',
  //     component: () => import('@/views/memberManagement/memberShip/addShip'),
  //     meta: {title: '添加套餐', icon: 'product-list'},
  //     hidden:true
  //   },
  //   {
  //     path: 'editShip',
  //     name: 'editShip',
  //     component: () => import('@/views/memberManagement/memberShip/editShip'),
  //     meta: {title: '编辑套餐', icon: 'product-list'},
  //     hidden:true
  //   }
  // ]
  // },
  // {
  //   path: '/activity',
  //   component: Layout,
  //   redirect: '/activity/activityList',
  //   name: 'activity',
  //   meta: {title: '活动管理', icon: 'example'},
  //   children: [{
  //     path: 'activityList',
  //     name: 'activityList',
  //     component: () => import('@/views/activity/activityList/index'),
  //     meta: {title: '活动列表', icon: 'example'}
  //   },
  //   {
  //     path: 'addActive',
  //     name: 'addActive',
  //     component: () => import('@/views/activity/activityList/addActive'),
  //     meta: {title: '新建活动', icon: 'product-add'},
  //     hidden:true
  //   } ,
  //   {
  //     path: 'detailActive',
  //     name: 'detailActive',
  //     component: () => import('@/views/activity/activityList/detailActive'),
  //     meta: {title: '活动详情', icon: 'product-add'},
  //     hidden:true
  //   },
  //   {
  //     path: 'editlActive',
  //     name: 'editlActive',
  //     component: () => import('@/views/activity/activityList/editActive'),
  //     meta: {title: '编辑活动', icon: 'product-add'},
  //     hidden:true
  //   }
  // ]
  // },
  // {
  //   path: '/coupon',
  //   component: Layout,
  //   redirect: '/coupon/couponList',
  //   name: 'coupon',
  //   meta: {title: '优惠券管理', icon: 'product'},
  //   children: [{
  //     path: 'couponList',
  //     name: 'couponList',
  //     component: () => import('@/views/couponManagement/couponList/index'),
  //     meta: {title: '优惠券列表', icon: 'product-list'}
  //   },
  //   {
  //     path: 'addCoupon',
  //     name: 'addCoupon',
  //     component: () => import('@/views/couponManagement/couponList/addCoupon'),
  //     meta: {title: '添加优惠券', icon: 'product-add'},
  //     hidden:true,
  //   },
  //   {
  //     path: 'editCoupon',
  //     name: 'editCoupon',
  //     component: () => import('@/views/couponManagement/couponList/editCoupon'),
  //     meta: {title: '编辑优惠券', icon: 'product-add'},
  //     hidden:true,
  //   },
  //   {
  //     path: 'detailCoupon',
  //     name: 'detailCoupon',
  //     component: () => import('@/views/couponManagement/couponList/detailCoupon'),
  //     meta: {title: '优惠券详情', icon: 'product-add'},
  //     hidden:true,
  //   }
  // ]
  // },
  // {
  //   path: '/comprehensive',
  //   component: Layout,
  //   redirect: '/comprehensive/dynamic',
  //   name: 'comprehensive',
  //   meta: {title: '综合管理', icon: 'product'},
  //   children: [{
  //     path: 'dynamic',
  //     name: 'dynamic',
  //     component: () => import('@/views/comprehensive/dynamics/index'),
  //     meta: {title: '动态管理', icon: 'product-list'}
  //   },
  //   {
  //     path: 'message',
  //     name: 'message',
  //     component: () => import('@/views/comprehensive/messagePush/index'),
  //     meta: {title: '消息推送', icon: 'product-add'},
  //   },
  //   {
  //     path: 'addMessage',
  //     name: 'addMessage',
  //     component: () => import('@/views/comprehensive/messagePush/addMessage'),
  //     meta: {title: '新增推送', icon: 'product-add'},
  //     hidden:true
  //   },
  // ]
  // },
  // {
  //   path: '/system',
  //   component: Layout,
  //   redirect: '/system/salesperson',
  //   name: 'system',
  //   meta: {title: '系统管理', icon: 'product'},
  //   children: [{
  //     path: 'salesperson',
  //     name: 'salesperson',
  //     component: () => import('@/views/system/Salesperson/index'),
  //     meta: {title: '业务员管理', icon: 'product-list'}
  //   },

  //   {
  //     path: 'addSperson',
  //     name: 'addSperson',
  //     component: () => import('@/views/system/Salesperson/addSperson'),
  //     meta: {title: '新增业务员', icon: 'ums-admin'},
  //     hidden: true
  //   },
  //   {
  //     path: 'detailSperson',
  //     name: 'detailSperson',
  //     component: () => import('@/views/system/Salesperson/detailSperson'),
  //     meta: {title: '业务员详情', icon: 'ums-admin'},
  //     hidden: true
  //   },
  //   {
  //     path: 'giftRoll',
  //     name: 'giftRoll',
  //     component: () => import('@/views/system/Salesperson/giftRoll'),
  //     meta: {title: '业务员详情', icon: 'ums-admin'},
  //     hidden: true
  //   },
  //   {
  //     path: 'merchant',
  //     name: 'merchant',
  //     component: () => import('@/views/system/merchant/index'),
  //     meta: {title: '商家管理', icon: 'ums-admin'}
  //   },
  //   {
  //     path: 'addMerchant',
  //     name: 'addMerchant',
  //     component: () => import('@/views/system/merchant/addMerchant'),
  //     meta: {title: '新增商家', icon: 'ums-admin'},
  //     hidden: true
  //   },
  //   {
  //     path: 'detailMerchant',
  //     name: 'detailMerchant',
  //     component: () => import('@/views/system/merchant/detailMerchant'),
  //     meta: {title: '商家详情', icon: 'ums-admin'},
  //     hidden: true
  //   }, {
  //     path: 'accountNumber',
  //     name: 'accountNumber',
  //     component: () => import('@/views/system/accountNumber/index'),
  //     meta: {title: '账号管理', icon: 'ums-admin'}
  //   },
  //   {
  //     path: 'addAcountNumber',
  //     name: 'addAcountNumber',
  //     component: () => import('@/views/system/accountNumber/addAcount'),
  //     meta: {title: '新增账号', icon: 'ums-admin'},
  //     hidden: true
  //   },
  //   {
  //     path: 'detailAcountNumber',
  //     name: 'detailAcountNumber',
  //     component: () => import('@/views/system/accountNumber/detailAcount'),
  //     meta: {title: '账号详情', icon: 'ums-admin'},
  //     hidden: true
  //   }
  // ]
  // },

]


// WEBPACK FOOTER //
// ./src/router/business.js